import React from 'react';

import Link from '../../../../library/link/link';
import ProductArticleStatusLabel from '../../../../components/product-article-status-label/product-article-status-label';

import { getShouldShowProductArticleStatusLabel } from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';

import './product-link.scss';

interface ProductLinkProps {
  onClick(): void;
  product: ProductData;
  renderIcon: React.ReactNode;
}

function ProductLink(props: ProductLinkProps) {
  const { onClick, product, renderIcon } = props;
  const { articleStatus, name, url } = product || {};

  if (!url || !name) {
    return null;
  }
  const shouldShowProductArticleStatusLabel =
    getShouldShowProductArticleStatusLabel(articleStatus);

  return (
    <div styleName="container">
      {shouldShowProductArticleStatusLabel && product?.articleStatus && (
        <ProductArticleStatusLabel articleStatus={product?.articleStatus} />
      )}
      <Link
        onClick={onClick}
        styleName={
          shouldShowProductArticleStatusLabel ? 'link-indented' : 'link'
        }
        to={url}
      >
        <>
          {renderIcon}
          {name}
        </>
      </Link>
    </div>
  );
}

export default ProductLink;
